const routes = [{
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/index.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/modifyPwd",
    name: "modifyPwd",
    component: () => import("@/pages/modifyPwd.vue"),
    meta: {
      title: "修改密码",
    },
  },
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/pages/user/setting/setting.vue"),
    meta: {
      title: "个人设置",
    },
  },


  {
    path: "/",
    name: "index",
    component: () => import("@/pages/index.vue"),
    redirect: "/homePage",
    meta: {
      home: true,
      // noKeepAlive: true,
    },
    children: [{
        path: "/homePage",
        name: "homePage",
        component: () => import("@/pages/homePage/index.vue"),
        meta: {
          home: true,
          toDoc: true,

          // noKeepAlive: true,
        },
      },
      {
        path: "/home",
        name: "home",
        component: () => import("@/pages/home/index.vue"),
        meta: {
          home: true,
          toDoc: true,

          // noKeepAlive: true,
        },
      },
      {
        path: "/check",
        name: "check",
        component: () => import("@/pages/check/index.vue"),
        meta: {
          home: true,
          title: "审批",
          toDoc: true,

          // noKeepAlive: true,
        },
      },
      {
        path: "/report",
        name: "report",
        component: () => import("@/pages/report/index.vue"),
        meta: {
          title: "分析统计",
          home: true,
          toDoc: true,

          // noKeepAlive: true,
        },
      },
      {
        path: "/user",
        name: "user",
        component: () => import("@/pages/user/index.vue"),
        meta: {
          title: "我的",
          home: true,
          toDoc: true,
          // noKeepAlive: true,
        },
      },
    ],
  },
  // {

  //     path: '/count/ordercompare',
  //     name: 'ordercompare',
  //     component: () => import('@/pages/count/ordercompare.vue'),
  //     meta: {
  //         title:'订单同比',
  //     }
  // },
  // {

  //     path: '/count/countchart',
  //     name: 'countchart',
  //     component: () => import('@/pages/count/countchart.vue'),
  //     meta: {
  //         title:'报表分析',
  //     }
  // },

  {
    path: "/count/categorycount",
    name: "categorycount",
    component: () => import("@/pages/report/equipmentRepair/equipmentType.vue"),
    meta: {
      title: "维修设备分类统计",
      keepAlive: true,
    },
  },
  {
    path: "/count/malfunctioncount",
    name: "malfunctioncount",
    component: () => import("@/pages/report/equipmentRepair/malfunction.vue"),
    meta: {
      title: "故障原因统计",
      keepAlive: true,
    },
  },
  {
    path: "/count/equipmentcount",
    name: "equipmentcount",
    component: () => import("@/pages/report/equipmentRepair/equipment.vue"),
    meta: {
      title: "维修设备统计",
      keepAlive: true,
    },
  },
  {
    path: "/count/repairRecord",
    name: "repairRecord",
    component: () => import("@/pages/report/equipmentRepair/repairRecord.vue"),
    meta: {
      title: "报修记录",
      keepAlive: true,
    },
  },
  {
    path: "/count/repairall",
    name: "analysisByRepairMan",
    component: () => import("@/pages/report/maintainStatistics/analysisByRepairMan.vue"),
    meta: {
      title: "维修统计",
    },
  },
  {
    path: "/count/repairManSelect",
    name: "repairManSelect",
    component: () => import("@/pages/report/maintainStatistics/repairManSelect.vue"),
    meta: {
      title: "维修统计",
    },
  },
  {
    path: "/count/listByRepairMan",
    name: "listByRepairMan",
    component: () => import("@/pages/report/maintainStatistics/listByRepairMan.vue"),
    meta: {
      title: "维修记录",
    },
  },
  {
    path: "/count/reportall",
    name: "analysisByReportMan",
    component: () => import("@/pages/report/repairStatistics/analysisByReportMan.vue"),
    meta: {
      title: "报修统计",
    },
  },
  {
    path: "/count/reportManSelect",
    name: "reportManSelect",
    component: () => import("@/pages/report/repairStatistics/reportManSelect.vue"),
    meta: {
      title: "报修统计",
    },
  },
  {
    path: "/count/listByReportMan",
    name: "listByReportMan",
    component: () => import("@/pages/report/repairStatistics/listByReportMan.vue"),
    meta: {
      title: "报修记录",
    },
  },

  {
    path: "/count/analysisBySalesMan",
    name: "analysisBySalesMan",
    component: () => import("@/pages/report/followupSalesManAnalysis/analysisBySalesMan.vue"),
    meta: {
      title: "业务员拜访统计",
    },
  },
  // {
  //   path: "/count/salesMan/analysisByCustomer",
  //   name: "salesManAnalysisByCustomer",
  //   component: () => import("@/pages/report/followupSalesManAnalysis/analysisByCustomer.vue"),
  //   meta: {
  //     title: "业务员拜访统计",
  //   },
  // },
  // {
  //   path: "/count/salesMan/salesManlistBy",
  //   name: "salesManlistBy",
  //   component: () => import("@/pages/report/followupSalesManAnalysis/salesManlistBy.vue"),
  //   meta: {
  //     title: "业务员拜访记录",
  //   },
  // },

  // {
  //   path: "/count/analysisByPurpose",
  //   name: "analysisByPurpose",
  //   component: () => import("@/pages/report/followupPurposeAnalysis/analysisByPurpose.vue"),
  //   meta: {
  //     title: "拜访目的统计",
  //   },
  // },
  // {
  //   path: "/count/purpose/analysisByFollowupType",
  //   name: "analysisByFollowupType",
  //   component: () => import("@/pages/report/followupPurposeAnalysis/analysisByFollowupType.vue"),
  //   meta: {
  //     title: "拜访目的统计",
  //   },
  // },
  // {
  //   path: "/count/purpose/analysisByCustomer",
  //   name: "purposeAnalysisByCustomer",
  //   component: () => import("@/pages/report/followupPurposeAnalysis/analysisByCustomer.vue"),
  //   meta: {
  //     title: "拜访目的统计",
  //   },
  // },
  // {
  //   path: "/count/purpose/purposeListBy",
  //   name: "purposeListBy",
  //   component: () => import("@/pages/report/followupPurposeAnalysis/purposeListBy.vue"),
  //   meta: {
  //     title: "拜访目的统计",
  //   },
  // },

  // {
  //   path: "/count/customer/analysisByCustomer",
  //   name: "analysisByCustomer",
  //   component: () => import("@/pages/report/followupCustomerAnalysis/analysisByCustomer.vue"),
  //   meta: {
  //     title: "客户拜访统计",
  //   },
  // },
  // {
  //   path: "/count/customer/customerListBy",
  //   name: "customerListBy",
  //   component: () => import("@/pages/report/followupCustomerAnalysis/customerListBy.vue"),
  //   meta: {
  //     title: "客户拜访列表",
  //   },
  // },

  // {
  //   path: "/count/customer/customerByChannel",
  //   name: "customerByChannel",
  //   component: () => import("@/pages/report/customerSourceAnalysis/customerByChannel.vue"),
  //   meta: {
  //     title: "客户来源统计",
  //   },
  // },
  // {
  //   path: "/count/customer/customerBySalesman",
  //   name: "customerBySalesman",
  //   component: () => import("@/pages/report/customerSourceAnalysis/customerBySalesman.vue"),
  //   meta: {
  //     title: "客户来源统计",
  //   },
  // },
  // {
  //   path: "/count/customer/channelListBy",
  //   name: "channelListBy",
  //   component: () => import("@/pages/report/customerSourceAnalysis/channelListBy.vue"),
  //   meta: {
  //     title: "客户列表",
  //   },
  // },

  // {
  //     path: '/count/contractTrendAnalysis/contractByDate',
  //     name: 'contractTrendByDate',
  //     component: () => import('@/pages/report/contractTrendAnalysis/contractByDate.vue'),
  //     meta: {
  //         title:'下降比例警示设置与提醒',
  //     }
  // },
  // {
  //     path: '/count/contractTrendAnalysis/contractListBy',
  //     name: 'contractTrendListBy',
  //     component: () => import('@/pages/report/contractTrendAnalysis/contractListBy.vue'),
  //     meta: {
  //         title:'合同列表',
  //     }
  // },

  // {
  //   path: "/count/salesManWeekAnalysis/analysisSalesMan",
  //   name: "AnalysisSalesMan",
  //   component: () => import("@/pages/report/salesManWeekAnalysis/analysisSalesMan.vue"),
  //   meta: {
  //     title: "拜访目标数据分析",
  //   },
  // },
  // {
  //   path: "/count/salesManTargetAnalysis/index",
  //   name: "SalesManTargetAnalysis",
  //   component: () => import("@/pages/report/salesManTargetAnalysis/index.vue"),
  //   meta: {
  //     title: "销售目标数据分析",
  //   },
  // },
  // {
  //   path: "/count/salesManTaskAnalysis/index",
  //   name: "SalesManTaskAnalysis",
  //   component: () => import("@/pages/report/salesManTaskAnalysis/salesManTaskAnalysis.vue"),
  //   meta: {
  //     title: "业务员达成率统计",
  //   },
  // },
  // {
  //   path: "/count/customerTaskAnalysis/index",
  //   name: "CustomerTaskAnalysis",
  //   component: () => import("@/pages/report/customerTaskAnalysis/customerTaskAnalysis.vue"),
  //   meta: {
  //     title: "客户拜访计划及达成情况",
  //   },
  // },
  // {
  //   path: "/count/contractOrderedAnalysis/analysisBySalesMan",
  //   name: "ContractOrderedAnalysisBySalesMan",
  //   component: () => import("@/pages/report/contractOrderedAnalysis/analysisBySalesMan.vue"),
  //   meta: {
  //     title: "落单率统计",
  //   },
  // },
  // {
  //   path: "/count/contractOrderedAnalysis/analysisByCustomer",
  //   name: "ContractOrderedAnalysisByCustomer",
  //   component: () => import("@/pages/report/contractOrderedAnalysis/analysisByCustomer.vue"),
  //   meta: {
  //     title: "落单率统计",
  //   },
  // },
  // {
  //   path: "/count/contractOrderedAnalysis/listByContractOrdered",
  //   name: "ContractOrderedAnalysisListBy",
  //   component: () => import("@/pages/report/contractOrderedAnalysis/listByContractOrdered.vue"),
  //   meta: {
  //     title: "合同列表",
  //   },
  // },
  // {
  //   path: "/count/salesManNewCustomerOrderedAnalysis/analysisBySalesMan",
  //   name: "SalesManNewCustomerOrderedAnalysisBySalesMan",
  //   component: () => import("@/pages/report/salesManNewCustomerOrderedAnalysis/analysisBySalesMan.vue"),
  //   meta: {
  //     title: "新客下单情况",
  //   },
  // },
  // {
  //   path: "/count/salesManNewCustomerOrderedAnalysis/listByContractOrdered",
  //   name: "SalesManNewCustomerOrderedAnalysisListBy",
  //   component: () => import("@/pages/report/salesManNewCustomerOrderedAnalysis/listBy.vue"),
  //   meta: {
  //     title: "合同列表",
  //   },
  // },

  // {
  //   path: "/count/salesManContractAnalysis/analysisBySalesMan",
  //   name: "SalesManContractAnalysisBySalesMan",
  //   component: () => import("@/pages/report/salesManContractAnalysis/analysisBySalesMan.vue"),
  //   meta: {
  //     title: "业务员每月下单统计",
  //   },
  // },
  // {
  //   path: "/count/salesManContractAnalysis/analysisByDay",
  //   name: "SalesManContractAnalysisByDay",
  //   component: () => import("@/pages/report/salesManContractAnalysis/analysisByDay.vue"),
  //   meta: {
  //     title: "业务员每月下单统计",
  //   },
  // },
  // {
  //   path: "/count/salesManContractAnalysis/listBySalesManContractAnalysis",
  //   name: "SalesManContractAnalysisListBy",
  //   component: () => import("@/pages/report/salesManContractAnalysis/listBy.vue"),
  //   meta: {
  //     title: "合同列表",
  //   },
  // },

  // {
  //   path: "/count/customerSalesAnalysis/analysisByMonth",
  //   name: "CustomerSalesAnalysisByMonth",
  //   component: () => import("@/pages/report/customerSalesAnalysis/analysisByMonth.vue"),
  //   meta: {
  //     title: "客户销售额分析",
  //   },
  // },
  // {
  //   path: "/count/customerSalesAnalysis/listby",
  //   name: "CustomerSalesAnalysislistby",
  //   component: () => import("@/pages/report/customerSalesAnalysis/listby.vue"),
  //   meta: {
  //     title: "送货单列表",
  //   },
  // },
  // {
  //   path: "/count/customerDeptAnalysis/analysisbySalesMan",
  //   name: "customerDeptAnalysisBySalesMan",
  //   component: () => import("@/pages/report/customerDeptAnalysis/analysisbySalesMan.vue"),
  //   meta: {
  //     title: "客户欠款分析",
  //   },
  // },
  // {
  //   path: "/count/customerDeptAnalysis/analysisbyCustomer",
  //   name: "customerDeptAnalysisByCustomer",
  //   component: () => import("@/pages/report/customerDeptAnalysis/analysisbyCustomer.vue"),
  //   meta: {
  //     title: "客户欠款分析",
  //   },
  // },
  // {
  //   path: "/count/customerDeptAnalysis/listby",
  //   name: "customerDeptAnalysislistby",
  //   component: () => import("@/pages/report/customerDeptAnalysis/listby.vue"),
  //   meta: {
  //     title: "客户欠款列表",
  //   },
  // },

  {
    path: "/analysis/trend/contractTrendAnalysis",
    name: "contractTrendAnalysis",
    component: () => import("@/pages/report/analysis/trend/contractTrendAnalysis/index.vue"),
    meta: {
      title: "接单趋势",
      print: true,
    },
  },
  {
    path: "/analysis/trend/contractTrendAnalysis/list",
    name: "contractTrendAnalysisList",
    component: () => import("@/pages/report/analysis/trend/contractTrendAnalysis/list.vue"),
    meta: {
      title: "接单趋势列表",
    },
  },
  {
    path: "/analysis/followupAnalysis",
    name: "followAnalysis",
    component: () => import("@/pages/report/analysis/followupAnalysis/index.vue"),
    meta: {
      title: "拜访汇总",
      print: true,
    },
  },
  {
    path: "/analysis/followupAnalysis/list",
    name: "followAnalysisList",
    component: () => import("@/pages/report/analysis/followupAnalysis/list.vue"),
    meta: {
      title: "拜访汇总列表",
    },
  },
  {
    path: "/analysis/followupNewCustomerAnalysis",
    name: "followupNewCustomerAnalysis",
    component: () => import("@/pages/report/analysis/followupNewCustomerAnalysis/index.vue"),
    meta: {
      title: "新客拜访统计",
      print: true,
    },
  },
  {
    path: "/analysis/followupNewCustomerAnalysis/list",
    name: "followupNewCustomerAnalysisList",
    component: () => import("@/pages/report/analysis/followupNewCustomerAnalysis/list.vue"),
    meta: {
      title: "新客拜访列表",
    },
  },
  {
    path: "/analysis/trend/followupTrendAnalysis",
    name: "followupTrendAnalysis",
    component: () => import("@/pages/report/analysis/trend/followupTrendAnalysis/index.vue"),
    meta: {
      title: "拜访趋势",
      print: true,
    },
  },
  {
    path: "/analysis/trend/followupTrendAnalysis/list",
    name: "followupTrendAnalysisList",
    component: () => import("@/pages/report/analysis/trend/followupTrendAnalysis/list.vue"),
    meta: {
      title: "拜访趋势列表",
    },
  },
  {
    path: "/analysis/contractAnalysis",
    name: "contractAnalysis",
    component: () => import("@/pages/report/analysis/contractAnalysis/index.vue"),
    meta: {
      title: "落单率统计",
      print: true,
    },
  },
  {
    path: "/analysis/contractAnalysis/list",
    name: "contractAnalysisList",
    component: () => import("@/pages/report/analysis/contractAnalysis/list.vue"),
    meta: {
      title: "合同列表",
    },
  },
  {
    path: "/analysis/contractAnalysis/detail",
    name: "contractAnalysisDetailList",
    component: () => import("@/pages/report/analysis/contractAnalysis/detail.vue"),
    meta: {
      title: "合同详情",
    },
  },
    {
        path: "/analysis/contractAnalysis/contractAnalysisBySum",
        name: "contractAnalysisBySum",
        component: () => import("@/pages/report/analysis/contractAnalysis/contractAnalysisBySum.vue"),
        meta: {
            title: "客户落单统计",
        },
    },
  {
    path: "/analysis/contractNewCustomerAnalysis",
    name: "contractNewCustomerAnalysis",
    component: () => import("@/pages/report/analysis/contractNewCustomerAnalysis/index.vue"),
    meta: {
      title: "新客落单率统计",
    },
  },
  {
    path: "/analysis/contractNewCustomerAnalysis/list",
    name: "contractNewCustomerAnalysisList",
    component: () => import("@/pages/report/analysis/contractNewCustomerAnalysis/list.vue"),
    meta: {
      title: "合同列表",
    },
  },
  {
    path: "/analysis/reportAnalysis",
    name: "reportAnalysis",
    component: () => import("@/pages/report/analysis/reportAnalysis/index.vue"),
    meta: {
      title: "客户报备汇总",
      print: true,
    },
  },
  {
    path: "/analysis/reportAnalysis/list",
    name: "reportAnalysisList",
    component: () => import("@/pages/report/analysis/reportAnalysis/list.vue"),
    meta: {
      title: "客户报备汇总列表",
    },
  },
  {
    path: "/analysis/orderedProductAnalysis",
    name: "orderedProductAnalysis",
    component: () => import("@/pages/report/analysis/orderedProductAnalysis/index.vue"),
    meta: {
      title: "合同产品统计",
      print: true,
    },
  },
  {
    path: "/analysis/orderedProductAnalysis/list",
    name: "orderedProductAnalysisList",
    component: () => import("@/pages/report/analysis/orderedProductAnalysis/list.vue"),
    meta: {
      title: "合同产品列表",
    },
  },
  {
    path: "/analysis/cucstomerServeAnalysis",
    name: "cucstomerServeAnalysis",
    component: () => import("@/pages/report/analysis/cucstomerServeAnalysis/index.vue"),
    meta: {
      title: "客户服务统计",
      print: true,
    },
  },
  {
    path: "/analysis/cucstomerServeAnalysis/list",
    name: "cucstomerServeAnalysisList",
    component: () => import("@/pages/report/analysis/cucstomerServeAnalysis/list.vue"),
    meta: {
      title: "客户服务统计",
    },
  },
  {
    path: "/analysis/deliveryProductAnalysis",
    name: "deliveryProductAnalysis",
    component: () => import("@/pages/report/analysis/deliveryProductAnalysis/index.vue"),
    meta: {
      title: "",
      print: true,
    },
  },
  {
    path: "/analysis/deliveryProductAnalysis/deliveryAnalysisBySum",
    name: "deliveryAnalysisBySum",
    component: () => import("@/pages/report/analysis/deliveryProductAnalysis/deliveryAnalysisBySum.vue"),
    meta: {
      title: "销售客户列表",
      print: true,
    },
  },
  {
    path: "/analysis/deliveryProductAnalysis/list",
    name: "deliveryProductAnalysisList",
    component: () => import("@/pages/report/analysis/deliveryProductAnalysis/list.vue"),
    meta: {
      title: "销售送货单列表",
      print: true,
    },
  },
  {
    path: "/analysis/deliveryProductAnalysis/deliveryAnalysisList",
    name: "deliveryAnalysisList",
    component: () => import("@/pages/report/analysis/deliveryProductAnalysis/deliveryAnalysisList.vue"),
    meta: {
      title: "销售产品统计列表",
    },
  },
  {
    path: "/analysis/debtAnalysis",
    name: "debtAnalysis",
    component: () => import("@/pages/report/analysis/debtAnalysis/index.vue"),
    meta: {
      title: "客户欠款统计",
      print: true,
    },
  },
  {
    path: "/analysis/debtAnalysis/list",
    name: "debtAnalysisList",
    component: () => import("@/pages/report/analysis/debtAnalysis/list.vue"),
    meta: {
      title: "欠款统计列表",
    },
  },
  {
    path: "/analysis/debtAnalysis/listBySum",
    name: "custDebtAnalysisBySum",
    component: () => import("@/pages/report/analysis/debtAnalysis/listBySum.vue"),
    meta: {
      title: "欠款统计列表",
    },
  },
  {
    path: "/analysis/debtAnalysis/listByMonth",
    name: "custDebtAnalysisList",
    component: () => import("@/pages/report/analysis/debtAnalysis/listByMonth.vue"),
    meta: {
      title: "欠款统计列表",
    },
  },
  {
    path: "/analysis/receiptAnalysis",
    name: "receiptAnalysis",
    component: () => import("@/pages/report/analysis/receiptAnalysis/index.vue"),
    meta: {
      title: "客户收款统计",
      print: true,
    },
  },
  {
    path: "/analysis/receiptAnalysis/list",
    name: "receiptAnalysisList",
    component: () => import("@/pages/report/analysis/receiptAnalysis/list.vue"),
    meta: {
      title: "收款统计列表",
    },
  },
  {
    path: "/analysis/receiptAnalysis/listBySum",
    name: "receiptAnalysisBySum",
    component: () => import("@/pages/report/analysis/receiptAnalysis/listBySum.vue"),
    meta: {
      title: "收款客户统计列表",
    },
  },
  {
    path: "/analysis/followupTaskAnalysis",
    name: "followupTaskAnalysis",
    component: () => import("@/pages/report/analysis/followupTaskAnalysis/index.vue"),
    meta: {
      title: "业务员达成率分析",
      print: true,
    },
  },
  {
    path: "/analysis/followupTaskAnalysis/list",
    name: "followupTaskAnalysisList",
    component: () => import("@/pages/report/analysis/followupTaskAnalysis/list.vue"),
    meta: {
      title: "业务员拜访列表",
    },
  },

  {
    path: "/analysis/task/achievementFollowupAnalysis",
    name: "AchievementfollowupAnalysis",
    component: () => import("@/pages/report/analysis/task/achievementFollowupAnalysis/index.vue"),
    meta: {
      title: "业务员拜访任务",
      print: true,
    },
  },
  {
    path: "/analysis/task/achievementFollowupAnalysis/list",
    name: "AchievementfollowupAnalysisList",
    component: () => import("@/pages/report/analysis/task/achievementFollowupAnalysis/list.vue"),
    meta: {
      title: "业务员拜访列表",
    },
  },
  {
    path: "/analysis/task/customerFollowupTaskAnalysis",
    name: "AchievementcustomerFollowupTaskAnalysis",
    component: () => import("@/pages/report/analysis/task/customerFollowupTaskAnalysis/index.vue"),
    meta: {
      title: "客户拜访任务",
      print: true,
    },
  },
  {
    path: "/analysis/task/customerFollowupTaskAnalysis/list",
    name: "AchievementCustomerFollowupTaskAnalysisList",
    component: () => import("@/pages/report/analysis/task/customerFollowupTaskAnalysis/list.vue"),
    meta: {
      title: "客户拜访列表",
    },
  },
  {
    path: "/analysis/task/achievementCustomerReportAnalysis",
    name: "AchievementCustomerReportAnalysis",
    component: () => import("@/pages/report/analysis/task/achievementCustomerReportAnalysis/index.vue"),
    meta: {
      title: "报备目标达成率",
      print: true,
    },
  },
  {
    path: "/analysis/task/achievementCustomerReportAnalysis/list",
    name: "AchievementCustomerReportAnalysisList",
    component: () => import("@/pages/report/analysis/task/achievementCustomerReportAnalysis/list.vue"),
    meta: {
      title: "客户报备列表",
    },
  },
  {
    path: "/analysis/task/achievementNewCustomerFollowupAnalysis",
    name: "AchievementNewCustomerFollowupAnalysis",
    component: () => import("@/pages/report/analysis/task/achievementNewCustomerFollowupAnalysis/index.vue"),
    meta: {
      title: "新客拜访任务",
      print: true,
    },
  },
  {
    path: "/analysis/task/achievementNewCustomerFollowupAnalysis/list",
    name: "AchievementNewCustomerFollowupAnalysisList",
    component: () => import("@/pages/report/analysis/task/achievementNewCustomerFollowupAnalysis/list.vue"),
    meta: {
      title: "新客拜访列表",
    },
  },
  {
    path: "/analysis/task/achievementNewCustomerOrderAmountAnalysis",
    name: "AchievementNewCustomerOrderAmountAnalysis",
    component: () => import("@/pages/report/analysis/task/achievementNewCustomerOrderAmountAnalysis/index.vue"),
    meta: {
      title: "新客落单额",
      print: true,
    },
  },
  {
    path: "/analysis/task/achievementNewCustomerOrderAmountAnalysis/list",
    name: "AchievementNewCustomerOrderAmountAnalysisList",
    component: () => import("@/pages/report/analysis/task/achievementNewCustomerOrderAmountAnalysis/list.vue"),
    meta: {
      title: "新客落单列表",
    },
  },
  {
    path: "/analysis/task/achievementOrderAmountAnalysis",
    name: "AchievementOrderAmountAnalysisAnalysis",
    component: () => import("@/pages/report/analysis/task/achievementOrderAmountAnalysis/index.vue"),
    meta: {
      title: "业务员落单额",
      print: true,
    },
  },
  {
    path: "/analysis/task/achievementOrderAmountAnalysis/list",
    name: "AchievementOrderAmountAnalysisAnalysisList",
    component: () => import("@/pages/report/analysis/task/achievementOrderAmountAnalysis/list.vue"),
    meta: {
      title: "销售列表",
    },
  },

  {
    path: "/analysis/task/dailyOrderCompleteCompletionRateAnalysis",
    name: "DailyOrderCompleteCompletionRateAnalysis",
    component: () => import("@/pages/report/analysis/task/dailyOrderCompleteCompletionRateAnalysis/index.vue"),
    meta: {
      title: "每天落单完成率",
    },
  },

  {
    path: "/analysis/ordered/comparison",
    name: "OrderedComparison",
    component: () => import("@/pages/report/analysis/ordered/comparison/index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/analysis/sales/comparison",
    name: "SalesComparison",
    component: () => import("@/pages/report/analysis/sales/comparison/index.vue"),
    meta: {
      title: "销售对比",
    },
  },
  {
    path: "/analysis/sales/comparison/followupList",
    name: "SalesComparisonFollowupList",
    component: () => import("@/pages/report/analysis/sales/comparison/followupList.vue"),
    meta: {
      title: "拜访列表",
    },
  },

  {
    path: "/analysis/trend/salesTrendAnalysis",
    name: "salesTrendAnalysis",
    component: () => import("@/pages/report/analysis/trend/salesTrendAnalysis/index.vue"),
    meta: {
      title: "销售趋势",
      print: true,
    },
  },
  {
    path: "/analysis/trend/salesTrendAnalysis/list",
    name: "salesTrendAnalysisList",
    component: () => import("@/pages/report/analysis/trend/salesTrendAnalysis/list.vue"),
    meta: {
      title: "销售列表",
    },
  },
  {
    path: "/analysis/task/customerSalesAmountAnalysis",
    name: "customerSalesAmountAnalysis",
    component: () => import("@/pages/report/analysis/task/customerSalesAmountAnalysis/index.vue"),
    meta: {
      title: "销售分析",
      print: true,
    },
  },
  {
    path: "/analysis/task/customerSalesAmountAnalysis/list",
    name: "customerSalesAmountAnalysisList",
    component: () => import("@/pages/report/analysis/task/customerSalesAmountAnalysis/list.vue"),
    meta: {
      title: "销售列表",
    },
  },
  {
    path: "/analysis/orderBrandAnalysis",
    name: "orderBrandAnalysis",
    component: () => import("@/pages/report/analysis/orderBrandAnalysis/index.vue"),
    meta: {
      title: "产地统计",
    },
  },
  {
    path: "/analysis/orderBrandAnalysis/list",
    name: "orderBrandAnalysisList",
    component: () => import("@/pages/report/analysis/orderBrandAnalysis/list.vue"),
    meta: {
      title: "产地统计",
    },
  },

  // {
  //     path: '/count/salesMan/salesMan',
  //     name: 'channelListBy',
  //     component: () => import('@/pages/report/salesMan/salesMan.vue'),
  //     meta: {
  //         title:'客户列表',
  //     }
  // },

  // {
  //     path: '/count/repairchart',
  //     name: 'repairchart',
  //     component: () => import('@/pages/report/repairchart.vue'),
  //     meta: {
  //         title:'月计维修',
  //     }
  // },
  // {

  //     path: '/count/crmchart',
  //     name: 'crmchart',
  //     component: () => import('@/pages/count/crmchart.vue'),
  //     meta: {
  //         title:'CRM统计',
  //     }
  // },

  // {
  //     path: '/count/categorycount',
  //     name: 'categorycount',
  //     component: () => import('@/pages/report/categorycount.vue'),
  //     meta: {
  //         title:'故障类别',
  //         keepAlive:true,
  //     }
  // },
  // {
  //     path: '/count/repaircount',
  //     name: 'repaircount',
  //     component: () => import('@/pages/report/repaircount.vue'),
  //     meta: {
  //         title:'每日报修',
  //     }
  // },
  // {
  //     path: '/count/repairall',
  //     name: 'repairall',
  //     component: () => import('@/pages/report/repairall.vue'),
  //     meta: {
  //         title:'维修统计',
  //     }
  // },

  ////notice
  {
    path: "/notice/quoted",
    name: "Noticequoted",
    component: () => import("@/pages/notice/quoted/index.vue"),
    meta: {
      title: "大额报价未落单提醒",
    },
  },
  {
    path: "/notice/csDispatch",
    name: "NoticecsDispatch",
    component: () => import("@/pages/notice/csDispatch/index.vue"),
    meta: {
      title: "客户服务超时未指派提醒",
    },
  },
  {
    path: "/notice/csfollowup",
    name: "Noticecsfollowup",
    component: () => import("@/pages/notice/csfollowup/index.vue"),
    meta: {
      title: "客户服务超时未跟进提醒",
    },
  },
  {
    path: "/notice/csComplete",
    name: "NoticecsComplete",
    component: () => import("@/pages/notice/csComplete/index.vue"),
    meta: {
      title: "客户服务超时未完成提醒",
    },
  },
  {
    path: "/notice/contractTrend",
    name: "NoticecontractTrend",
    component: () => import("@/pages/notice/contractTrend/index.vue"),
    meta: {
      title: "客户下单异常",
    },
  },
  {
    path: "/sampleRequestForm/list",
    name: "SampleRequestFormList",
    component: () => import("@/pages/sampleRequestForm/list.vue"),
    meta: {
      title: "样品申请单",
      search: true,
    },
  },
  {
    path: "/sampleRequestForm/list",
    name: "SampleRequestFormList",
    component: () => import("@/pages/sampleRequestForm/list.vue"),
    meta: {
      title: "样品申请单",
      search: true,
    },
  },
  {
    path: "/sampleRequestForm/detail",
    name: "SampleRequestFormDetail",
    component: () => import("@/pages/sampleRequestForm/detail.vue"),
    meta: {
      title: "样品申请单详情",
    },
  },
  {
    path: "/sampleRequestForm/sampleRequestFormDetail/list",
    name: "sampleRequestFormDetailList",
    component: () => import("@/pages/sampleRequestForm/sampleRequestFormDetail/list.vue"),
    meta: {
      title: "样品申请单明细",
    },
  },
  {
    path: "/salesManFollowupTaskConfig/list",
    name: "salesManFollowupTaskConfigList",
    component: () => import("@/pages/salesManFollowupTaskConfig/list.vue"),
    meta: {
      title: "周拜访目标",
      // search: true,
    },
  },
  {
    path: "/salesManTargetConfig/list",
    name: "SalesManTargetConfigList",
    component: () => import("@/pages/salesManTargetConfig/list.vue"),
    meta: {
      title: " 销售目标",
      search: true,
    },
  },

  {
    path: "/customerDebt/list",
    name: "customerDebtList",
    component: () => import("@/pages/customerDept/list.vue"),
    meta: {
      title: "客户欠款",
      search: true,
    },
  },
  {
    path: "/customerDebt/listBySum",
    name: "customerDebtListBySum",
    component: () => import("@/pages/customerDept/listBySum.vue"),
    meta: {
      title: "客户欠款统计",
      search: true,
    },
  },
  {
    path: "/customerDebt/listByMonth",
    name: "customerDebtListByMonth",
    component: () => import("@/pages/customerDept/listByMonth.vue"),
    meta: {
      title: "客户欠款按月统计",
      search: false,
    },
  },
  {
    path: "/customerDebt/detail",
    name: "customerDebtDetail",
    component: () => import("@/pages/customerDept/detail.vue"),
    meta: {
      title: "客户欠款详情",
    },
  },
  {
    path: "/receipt/list",
    name: "receiptList",
    component: () => import("@/pages/receipt/list.vue"),
    meta: {
      title: "客户收款",
      search: true,
    },
  },
  {
    path: "/receipt/detail",
    name: "receiptDetail",
    component: () => import("@/pages/receipt/detail.vue"),
    meta: {
      title: "客户收款详情",
    },
  },
  {
    path: "/dimissionList/list",
    name: "DimissionList",
    component: () => import("@/pages/dimissionList/list.vue"),
    meta: {
      title: "离职继承",
      // search: true,
    },
  },
  {
    path: "/unassociated/list",
    name: "Unassociated",
    component: () => import("@/pages/unassociated/list.vue"),
    meta: {
      title: "无员工关联的业务员列表",
      // search: true,
    },
  },
  {
    path: "/map",
    name: "Map",
    component: () => import("@/pages/map/index.vue"),
    meta: {
      title: "附近客户",
      // search: true,
    },
  },

  {
    path: "/home/crm/task/customerFollowupTask",
    name: "customerFollowupTask",
    component: () => import("@/pages/home/crm/task/customerFollowupTask/index.vue"),
    meta: {
      title: "客户拜访任务",
      // search: true,
    },
  },
  {
    path: "/home/crm/task/customerSalesAmount",
    name: "customerSalesTask",
    component: () => import("@/pages/home/crm/task/customerSalesAmount/index.vue"),
    meta: {
      title: "客户销售目标",
      // search: true,
    },
  },
  {
    path: "/home/crm/task/achievementCustomerReport",
    name: "achievementCustomerReport",
    component: () => import("@/pages/home/crm/task/achievementCustomerReport/index.vue"),
    meta: {
      title: "报备任务设置",
      // search: true,
    },
  },
  // {
  //   path: "/home/crm/task/achievementNewCustomerFollowup",
  //   name: "achievementNewCustomerFollowup",
  //   component: () => import("@/pages/home/crm/task/achievementNewCustomerFollowup/index.vue"),
  //   meta: {
  //     title: "新客拜访任务",
  //     // search: true,
  //   },
  // },
  // {
  //   path: "/home/crm/task/achievementNewCustomerOrderedAmount",
  //   name: "achievementNewCustomerOrderedAmount",
  //   component: () => import("@/pages/home/crm/task/achievementNewCustomerOrderedAmount/index.vue"),
  //   meta: {
  //     title: "新客落单额",
  //     // search: true,
  //   },
  // },
  {
    path: "/home/crm/task/achievementOrderedAmount",
    name: "achievementOrderedAmount",
    component: () => import("@/pages/home/crm/task/achievementOrderedAmount/index.vue"),
    meta: {
      title: "业务员销售目标",
      // search: true,
    },
  },
  {
    path: "/home/crm/task/achievementFollowup",
    name: "achievementFollowup",
    component: () => import("@/pages/home/crm/task/achievementFollowup/index.vue"),
    meta: {
      title: "业务员拜访任务",
      // search: true,
    },
  },

  {
    path: "/customerServe/creat/list",
    name: "CustomerServeCreat",
    component: () => import("@/pages/customerServe/creat/list.vue"),
    meta: {
      title: "客户服务管理",
      search: true,
    },
  },
  {
    path: "/customerServe/creat/detail",
    name: "CustomerServeDetail",
    component: () => import("@/pages/customerServe/creat/detail.vue"),
    meta: {
      title: "客户服务详情",
    },
  },
  {
    path: "/customerServe/product/handle",
    name: "CustomerServeHandle",
    component: () => import("@/pages/customerServe/product/handle.vue"),
    meta: {
      title: "配置领料清单",
    },
  },
  {
    path: "/customerServe/followup/detail",
    name: "CustomerServeFollowupDetail",
    component: () => import("@/pages/customerServe/followup/detail.vue"),
    meta: {
      title: "客户服务跟进详情",
    },
  },
  {
    path: "/customerServe/myFollowup",
    name: "CustomerServeMyFollowup",
    component: () => import("@/pages/customerServe/myFollowup/index.vue"),
    meta: {
      title: "客户服务跟进",
      search: true,
    },
  },
  {
    path: "/customerServe/myFollowup/endFollow",
    name: "CustomerServeMyFollowupConfirm",
    component: () => import("@/pages/customerServe/myFollowup/endFollow/index.vue"),
    meta: {
      title: "提交跟进",
    },
  },
  {
    path: "/customerServe/comfirm",
    name: "CustomerServeConfirm",
    component: () => import("@/pages/customerServe/comfirm/index.vue"),
    meta: {
      title: "派单及确认",
      search: true,
    },
  },
  {
    path: "/customerServe/comfirm/detail",
    name: "CustomerServeConfirmDetail",
    component: () => import("@/pages/customerServe/comfirm/detail.vue"),
    meta: {
      title: "派单详情",
    },
  },
  {
    path: "/customerServe/info",
    name: "CustomerServeInfo",
    component: () => import("@/pages/customerServe/info/index.vue"),
    meta: {
      title: "客户服务进度查询",
      // search: true,
    },
  },
  {
    path: "/customerServe/question",
    name: "CustomerServeQuestion",
    component: () => import("@/pages/customerServe/question/index.vue"),
    meta: {
      title: "问题资料库",
      search: true,
    },
  },
  {
    path: "/customerServe/question/detail",
    name: "CustomerServeQuestionDetail",
    component: () => import("@/pages/customerServe/question/detail.vue"),
    meta: {
      title: "客户服务详情",
    },
  },
  {
    path: "/customerServe/servebyQrCode",
    name: "CustomerServeByQrCode",
    component: () => import("@/pages/customerServe/servebyQrCode/index.vue"),
    meta: {
      title: "客户服务",
    },
  },

  {
    path: "/customReport/index",
    name: "customReportIndex",
    component: () => import("@/pages/customReport/index.vue"),
    meta: {
      title: "自定义查询",
    },
  },
  {
    path: "/customReport",
    name: "customReport",
    component: () => import("@/pages/customReport/index.vue"),
    meta: {
      title: "自定义查询",
      search: true,
    },
  },

  {
    path: "/leads/list",
    name: "leadsList",
    component: () => import("@/pages/leads/list.vue"),
    meta: {
      title: "报备列表",
      search: true,
    },
  },
  {
    path: "/leads/detail",
    name: "leadsDetail",
    component: () => import("@/pages/leads/detail.vue"),
    meta: {
      title: "报备详情",
    },
  },
  {
    path: "/leads/info",
    name: "leadsInfo",
    component: () => import("@/pages/leads/info.vue"),
    meta: {
      // title: "报备详情",
    },
  },
  {
    path: "/recustomerquery/list",
    name: "customerqueryList",
    component: () => import("@/pages/recustomerquery/list.vue"),
    meta: {
      title: "客户查重列表",
    },
  },
  {
    path: "/customerPool/list",
    name: "customerPoolList",
    component: () => import("@/pages/customerPool/list.vue"),
    meta: {
      title: "公海池",
      search: true,
    },
  },
  {
    path: "/customerPool/detail",
    name: "customerPoolDetail",
    component: () => import("@/pages/customerPool/detail.vue"),
    meta: {
      title: "公海池详情",
    },
  },
  {
    path: "/salesmanSnapUp",
    name: "SalesmanSnapUp",
    component: () => import("@/pages/salesmanSnapUp/index.vue"),
    meta: {
      title: "业务员公海池抢客",
      search: true,
    },
  },
  {
    path: "/salesmanSnapUp/detail",
    name: "salesmanSnapUpDetail",
    component: () => import("@/pages/salesmanSnapUp/detail.vue"),
    meta: {
      title: "公海池详情",
    },
  },
  {
    path: "/customer/analysis/orderRank",
    name: "CustomerOrderRank",
    component: () => import("@/pages/customer/analysis/orderRank/index.vue"),
    meta: {
      title: "客户下单排名",
      // search: true,
    },
  },
  {
    path: "/customer/list",
    name: "customerList",
    component: () => import("@/pages/customer/list.vue"),
    meta: {
      title: "客户列表",
      search: true,
    },
  },
  {
    path: "/customer/detail",
    name: "customerDetail",
    component: () => import("@/pages/customer/detail.vue"),
    meta: {
      title: "客户详情",
    },
  },
  {
    path: "/customer/auditFactory",
    name: "customerAuditFactory",
    component: () => import("@/pages/customer/auditFactory/index.vue"),
    meta: {
      title: "审厂资料",
    },
  },
  {
    path: "/customer/auditFactory/detail",
    name: "customerAuditFactoryDetail",
    component: () => import("@/pages/customer/auditFactory/detail.vue"),
    meta: {
      title: "审厂资料",
    },
  },
  // {
  //   path: "/customer/showQrcode",
  //   name: "customerShowQrcode",
  //   component: () => import("@/pages/customer/showQrcode.vue"),
  //   meta: {
  //     title: "客户二维码",
  //   },
  // },
  {
    path: "/customer/customerEvaluation",
    name: "customerEvaluation",
    component: () => import("@/pages/customer/customerEvaluation/index.vue"),
    meta: {
      title: "客户评价",
    },
  },
  {
    path: "/customer/info",
    name: "customerInfo",
    component: () => import("@/pages/customer/info.vue"),
    meta: {
      // title: "客户详情",
    },
  },
  {
    path: "/customer/followup",
    name: "customerFollowup",
    component: () => import("@/pages/customer/followup/index.vue"),
    meta: {
      title: "拜访",
    },
  },
  {
    path: "/customer/operationdynamic",
    name: "customerOperationdynamic",
    component: () => import("@/pages/customer/operationdynamic/index.vue"),
    meta: {
      title: "操作日志",
    },
  },
  {
    path: "/customer/leads",
    name: "customerLeads",
    component: () => import("@/pages/customer/leads/index.vue"),
    meta: {
      title: "报备记录",
    },
  },
  {
    path: "/customer/linkman",
    name: "customerLinkMan",
    component: () => import("@/pages/customer/linkman/index.vue"),
    meta: {
      title: "联系人",
    },
  },
  {
    path: "/customer/dynamics",
    name: "customerDynamics",
    component: () => import("@/pages/customer/dynamics/index.vue"),
    meta: {
      title: "客户动态",
    },
  },
  {
    path: "/customer/analysis",
    name: "customerAnalysis",
    component: () => import("@/pages/customer/analysis/index.vue"),
    meta: {
      title: "客户统计",
    },
  },
  {
    path: "/customer/analysis/dailyOrderAmountAnalysis",
    name: "dailyOrderAmountAnalysis",
    component: () => import("@/pages/customer/analysis/dailyOrderAmountAnalysis/index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/customer/analysis/productAnalysis",
    name: "productAnalysis",
    component: () => import("@/pages/customer/analysis/productAnalysis/index.vue"),
    meta: {
      title: "",
    },
  },
  {
    path: "/customer/customerServe",
    name: "customerCustomerServe",
    component: () => import("@/pages/customer/customerServe/index.vue"),
    meta: {
      title: "客户统计",
    },
  },
  {
    path: "/customer/map",
    name: "customerAddress",
    component: () => import("@/pages/customer/map/index.vue"),
    meta: {
      title: "客户位置",
    },
  },
  {
    path: "/customer/customerRelation",
    name: "customerRelation",
    component: () => import("@/pages/customer/customerRelation/index.vue"),
    meta: {
      title: "关联客户",
    },
  },

  {
    path: "/crm/linkman",
    name: "customerLinkman",
    component: () => import("@/pages/customer/linkman/list.vue"),
    meta: {
      title: "联系人",
      search: true,
    },
  },

  {
    path: "/followup/list",
    name: "followupList",
    component: () => import("@/pages/followup/list.vue"),
    meta: {
      title: "拜访列表",
      search: true,
    },
  },
  {
    path: "/followup/timeLine",
    name: "followupTimeLine",
    component: () => import("@/pages/followup/timeLine.vue"),
    meta: {
      title: "拜访列表",
      search: true,
    },
  },
  {
    path: "/followup/signPage",
    name: "followupSignPage",
    component: () => import("@/pages/followup/signPage/index.vue"),
    meta: {
      title: "拜访记录",
    },
  },
  {
    path: "/followup/detail",
    name: "followupDetail",
    component: () => import("@/pages/followup/detail.vue"),
    meta: {
      title: "拜访详情",
    },
  },
  {
    path: "/followupOffice/list",
    name: "followupOfficeList",
    component: () => import("@/pages/followupOffice/list.vue"),
    meta: {
      title: "办事处打卡",
      search: true,
    },
  },
  {
    path: "/followupOffice/detail",
    name: "followupOfficeDetail",
    component: () => import("@/pages/followupOffice/detail.vue"),
    meta: {
      title: "打卡详情",
    },
  },

  {
    path: "/opportunity/list",
    name: "opportunityList",
    component: () => import("@/pages/opportunity/list.vue"),
    meta: {
      title: "送货单列表",
      search: true,
    },
  },
  {
    path: "/opportunity/detail",
    name: "opportunityDetail",
    component: () => import("@/pages/opportunity/detail.vue"),
    meta: {
      title: "送货单详情",
    },
  },
  {
    path: "/contract/list",
    name: "contractList",
    component: () => import("@/pages/contract/list.vue"),
    meta: {
      title: "合同列表",
      search: true,
    },
  },
  {
    path: "/contract/detail",
    name: "contractDetail",
    component: () => import("@/pages/contract/detail.vue"),
    meta: {
      title: "合同详情",
    },
  },
  {
    path: "/followupPlan/list",
    name: "followupPlanList",
    component: () => import("@/pages/followupPlan/list.vue"),
    meta: {
      title: "拜访计划",
      // search: true,
    },
  },
  {
    path: "/followupPlan/detail",
    name: "followupPlanDetail",
    component: () => import("@/pages/followupPlan/detail.vue"),
    meta: {
      title: "拜访计划详情",
    },
  },
  {
    path: "/followupSchedule/list",
    name: "followupSchedule",
    component: () => import("@/pages/followupSchedule/index.vue"),
    meta: {
      title: "我的日程",
    },
  },
  {
    path: "/followupSchedule/detail",
    name: "followupScheduleDetail",
    component: () => import("@/pages/followupSchedule/detail.vue"),
    meta: {
      title: "日程详情",
    },
  },
  {
    path: "/exception",
    name: "Exception",
    component: () => import("@/pages/exception/index.vue"),
    meta: {
      title: "异常客户查询",
      // search: true,
    },
  },
  {
    path: "/check/crm/approve",
    name: "ApproveList",
    component: () => import("@/pages/approve/list.vue"),
    meta: {
      title: "审核列表",
      search: true,
    },
  },

  {
    path: "/homePage/broad",
    name: "Broad",
    component: () => import("@/pages/homePage/broad/index.vue"),
    meta: {
      title: "数据看板",
      search: true,
    },
  },
  {
    path: "/homePage/broad/demo/followup/list",
    name: "BroadFollowupList",
    component: () => import("@/pages/homePage/broad/demo/followup/list.vue"),
    meta: {
      title: "拜访列表",
      search: true,
    },
  },
  {
    path: "/homePage/broad/demo/contract/list",
    name: "BroadContractList",
    component: () => import("@/pages/homePage/broad/demo/contract/list.vue"),
    meta: {
      title: "合同列表",
      search: true,
    },
  },
  {
    path: "/homePage/broad/demo/sales/list",
    name: "BroadSalesList",
    component: () => import("@/pages/homePage/broad/demo/sales/list.vue"),
    meta: {
      title: "送货列表",
      search: true,
    },
  },
  {
    path: "/homePage/broad/demo/customerServe/list",
    name: "BroadCustomerServeList",
    component: () => import("@/pages/homePage/broad/demo/customerServe/list.vue"),
    meta: {
      title: "客服列表",
      search: true,
    },
  },
  {
    path: "/homePage/broad/demo/leads/list",
    name: "BroadLeadsList",
    component: () => import("@/pages/homePage/broad/demo/leads/list.vue"),
    meta: {
      title: "报备列表",
      search: true,
    },
  },
  {
    path: "/homePage/broad/demo/leads/customerPool",
    name: "BroadCustomerPool",
    component: () => import("@/pages/homePage/broad/demo/leads/customerPool.vue"),
    meta: {
      title: "公海池列表",
      search: true,
    },
  },

  // {
  //   path: "/check/crm/leads",
  //   name: "leadsCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "报备审核",
  //     search: true,
  //   },
  // },
  // {
  //   path: "/check/crm/customer",
  //   name: "customerCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "客户审核",
  //     search: true,
  //   },
  // },
  // {
  //   path: "/check/crm/contract",
  //   name: "contractCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "合同审核",
  //     search: true,
  //   },
  // },
  // {
  //   path: "/check/crm/sampleRequestForm",
  //   name: "SampleRequestFormCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "样品申请单审核",
  //     search: true,
  //   },
  // },

  // {
  //   path: "/check/crm/afterSalesForm",
  //   name: "afterSalesFormCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "售后申请审核",
  //     search: true,
  //   },
  // },
  // {
  //   path: "/check/crm/afterSalesFormConfirm",
  //   name: "afterSalesFormConfirmCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "售后确认审核",
  //     search: true,
  //   },
  // },
  // {
  //   path: "/check/crm/customerPool",
  //   name: "customerPoolCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "进入公海确认审核",
  //     search: true,
  //   },
  // },
  // {
  //   path: "/check/crm/customerModify",
  //   name: "customerModifyCheck",
  //   component: () => import("@/pages/approve/list.vue"),
  //   meta: {
  //     title: "客户修改审核",
  //     search: true,
  //   },
  // },
  {
    path: "/check/detail",
    name: "checkDetail",
    component: () => import("@/pages/approve/detail.vue"),
    meta: {
      title: "审核详情",
    },
  },
  {
    path: "/check/compare",
    name: "checkCompare",
    component: () => import("@/pages/approve/compare.vue"),
    meta: {
      title: "修改对比",
    },
  },

  {
    path: "/base/item",
    name: "itemList",
    component: () => import("@/pages/base/item/index.vue"),
    meta: {
      title: "物料管理",
      search: true,
    },
  },
  {
    path: "/base/afterSalesType",
    name: "afterSalesType",
    component: () => import("@/pages/base/afterSalesType/index.vue"),
    meta: {
      title: "售后类别",
      search: true,
    },
  },
  {
    path: "/base/payment",
    name: "payment",
    component: () => import("@/pages/base/payment/index.vue"),
    meta: {
      title: "付款方式",
      search: true,
    },
  },
  {
    path: "/base/deliveryType",
    name: "deliveryType",
    component: () => import("@/pages/base/deliveryType/index.vue"),
    meta: {
      title: "送货方式",
      search: true,
    },
  },
  {
    path: "/base/unit",
    name: "unit",
    component: () => import("@/pages/base/unit/index.vue"),
    meta: {
      title: "物料单位",
      search: true,
    },
  },
  {
    path: "/base/customerPoolConfig/list",
    name: "customerPoolConfigList",
    component: () => import("@/pages/base/customerPoolConfig/list.vue"),
    meta: {
      title: "公海池配置",
      search: true,
    },
  },
  {
    path: "/base/customerPoolConfig",
    name: "customerPoolConfig",
    component: () => import("@/pages/base/customerPoolConfig/index.vue"),
    meta: {
      title: "公海池配置",
      search: true,
    },
  },
  {
    path: "/base/customerPoolConfig/previewCustomer",
    name: "customerPoolConfigPrevierCustomer",
    component: () => import("@/pages/base/customerPoolConfig/previewCustomer/index.vue"),
    meta: {
      title: "即将公海池",
      search: true,
    },
  },
  {
    path: "/base/serveType",
    name: "CustomerServeType",
    component: () => import("@/pages/base/serveType/index.vue"),
    meta: {
      title: "服务类别",
      search: true,
    },
  },
  {
    path: "/base/followupMatter",
    name: "FollowupMatter",
    component: () => import("@/pages/base/followupMatter/index.vue"),
    meta: {
      title: "拜访事项",
      search: true,
    },
  },
  {
    path: "/base/followupMatter/matter",
    name: "FollowupMatterMatter",
    component: () => import("@/pages/base/followupMatter/matter.vue"),
    meta: {
      title: "拜访事项",
      search: true,
    },
  },
  {
    path: "/home/crm/salesMan",
    name: "SalesMan",
    component: () => import("@/pages/home/crm/salesMan/index.vue"),
    meta: {
      title: "业务员管理",
      search: true,
    },
  },
  {
    path: "/home/crm/merchandiser",
    name: "Merchandiser",
    component: () => import("@/pages/home/crm/merchandiser/index.vue"),
    meta: {
      title: "跟单员管理",
      search: true,
    },
  },
  {
    path: "/home/crm/customerServeMan",
    name: "CustomerServeMan",
    component: () => import("@/pages/home/crm/customerServeMan/index.vue"),
    meta: {
      title: "客服管理",
      // search: true,
    },
  },
  {
    path: "/user/supportDoc",
    name: "supportDoc",
    component: () => import("@/pages/user/supportDoc/index.vue"),
    meta: {
      title: "帮助中心",
      // search: true,
    },
  },
  {
    path: "/user/supportDoc/detail",
    name: "supportDocDetail",
    component: () => import("@/pages/user/supportDoc/detail.vue"),
    meta: {
      title: "帮助中心",
      // search: true,
    },
  },
  {
    path: "/user/authentication",
    name: "Authentication",
    component: () => import("@/pages/user/authentication/index.vue"),
    meta: {
      title: "身份认证",
      // search: true,
    },
  },

  {
    path: "/user/systemPreserve/approveTypeConfig",
    name: "ApproveTypeConfig",
    component: () => import("@/pages/user/systemPreserve/approveTypeConfig/index.vue"),
    meta: {
      title: "审批类别配置",
      // search: true,
    },
  },
  {
    path: "/user/systemPreserve/organization",
    name: "Organization",
    component: () => import("@/pages/user/systemPreserve/organization/index.vue"),
    meta: {
      title: "组织管理",
      search: true,
    },
  },
  {
    path: "/user/systemPreserve/organization/detail",
    name: "OrganizationDetail",
    component: () => import("@/pages/user/systemPreserve/organization/detail.vue"),
    meta: {
      title: "组织详情",
      // search: true,
    },
  },
  {
    path: "/user/systemPreserve/remotecall",
    name: "Remotecall",
    component: () => import("@/pages/user/systemPreserve/remotecall/index.vue"),
    meta: {
      title: "数据接口",
      // search: true,
    },
  },
  {
    path: "/user/systemPreserve/remotecall/remoteConfig",
    name: "RemoteConfig",
    component: () => import("@/pages/user/systemPreserve/remotecall/remoteConfig/index.vue"),
    meta: {
      title: "接口配置",
      // search: true,
    },
  },
  {
    path: "/user/systemPreserve/remotecall/remoteSchedule",
    name: "RemoteSchedule",
    component: () => import("@/pages/user/systemPreserve/remotecall/remoteSchedule/index.vue"),
    meta: {
      title: "同步任务",
      // search: true,
    },
  },
  {
    path: "/user/systemPreserve/remotecall/remoteSchedule/detail",
    name: "RemoteScheduleDetail",
    component: () => import("@/pages/user/systemPreserve/remotecall/remoteSchedule/detail.vue"),
    meta: {
      title: "同步任务详情",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system",
    name: "System",
    component: () => import("@/pages/user/advancedSetting/system/index.vue"),
    meta: {
      title: "系统设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/base",
    name: "SystemBase",
    component: () => import("@/pages/user/advancedSetting/system/base.vue"),
    meta: {
      title: "基本设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/repair",
    name: "SystemRepair",
    component: () => import("@/pages/user/advancedSetting/system/repair.vue"),
    meta: {
      title: "报修设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/crm",
    name: "SystemCrm",
    component: () => import("@/pages/user/advancedSetting/system/crm.vue"),
    meta: {
      title: "客户设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/companyLocation",
    name: "SystemCompanyLocation",
    component: () => import("@/pages/user/advancedSetting/system/companyLocation.vue"),
    meta: {
      title: "公司位置设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/notice",
    name: "SystemNotice",
    component: () => import("@/pages/user/advancedSetting/system/notice.vue"),
    meta: {
      title: "通知设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/customerQuery",
    name: "SystemCustomerQuery",
    component: () => import("@/pages/user/advancedSetting/system/customerQuery.vue"),
    meta: {
      title: "客户查重设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/fieldCustomRequired",
    name: "SystemFieldCustomRequired",
    component: () => import("@/pages/user/advancedSetting/system/fieldCustomRequired.vue"),
    meta: {
      title: "自定义必填项设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/system/fieldCustom",
    name: "SystemFieldCustom",
    component: () => import("@/pages/user/advancedSetting/system/fieldCustom.vue"),
    meta: {
      title: "自定义表单项设置",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/appMenusConfig",
    name: "AppMenusConfig",
    component: () => import("@/pages/user/advancedSetting/appMenusConfig/index.vue"),
    meta: {
      title: "菜单设置",
      search: true,
    },
  },
  {
    path: "/user/advancedSetting/moduleOrganization",
    name: "ModuleOrganization",
    component: () => import("@/pages/user/advancedSetting/moduleOrganization/index.vue"),
    meta: {
      title: "模块设置",
    },
  },
  {
    path: "/user/advancedSetting/invite",
    name: "invite",
    component: () => import("@/pages/user/advancedSetting/invite/index.vue"),
    meta: {
      title: "邀请成员",
    },
  },
  {
    path: "/user/advancedSetting/salesManBind",
    name: "SalesManBind",
    component: () => import("@/pages/user/advancedSetting/salesManBind/index.vue"),
    meta: {
      title: "业务员绑定",
      // search: true,
    },
  },
  {
    path: "/home/role",
    name: "UserRole",
    component: () => import("@/pages/user/advancedSetting/userRole/index.vue"),
    meta: {
      title: "权限管理",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/customForm",
    name: "CustomForm",
    component: () => import("@/pages/user/advancedSetting/customForm/index.vue"),
    meta: {
      title: "自定义表单",
      // search: true,
    },
  },
  {
    path: "/user/advancedSetting/customForm/detail",
    name: "CustomFormDetail",
    component: () => import("@/pages/user/advancedSetting/customForm/detail.vue"),
    meta: {
      title: "自定义表单",
      // search: true,
    },
  },

  {
    path: "/repair/create",
    name: "repairCreate",
    component: () => import("@/pages/repair/create/index.vue"),
    meta: {
      title: "报修",
      search: true,
    },
  },
  {
    path: "/repair/detail/:active?",
    name: "repairDetail",
    component: () => import("@/pages/repair/create/detail.vue"),
    meta: {
      title: "报修",
    },
  },
  {
    path: "/repair/deviceType",
    name: "repairDeviceType",
    component: () => import("@/pages/repair/deviceType/index.vue"),
    meta: {
      title: "设备分类",
      search: true,
      add: true,
      props: true,
    },
  },
  {
    path: "/repair/device",
    name: "repairDevice",
    component: () => import("@/pages/repair/device/index.vue"),
    meta: {
      title: "设备管理",
      search: true,
      add: true,
      props: true,
    },
  },
  {
    path: "/base/department",
    name: "Department",
    component: () => import("@/pages/base/department/index.vue"),
    meta: {
      title: "部门管理",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/employee",
    name: "Employee",
    component: () => import("@/pages/base/employee/index.vue"),
    meta: {
      title: "员工管理",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/customerLevel",
    name: "CustomerLevel",
    component: () => import("@/pages/base/customerLevel/index.vue"),
    meta: {
      title: "客户级别",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/customerType",
    name: "CustomerType",
    component: () => import("@/pages/base/customerType/index.vue"),
    meta: {
      title: "客户类型",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/customerArea",
    name: "CustomerArea",
    component: () => import("@/pages/base/customerArea/index.vue"),
    meta: {
      title: "客户区域",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/followupPurpose",
    name: "FollowupPurpose",
    component: () => import("@/pages/base/followupPurpose/index.vue"),
    meta: {
      title: "跟进目的",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/channel",
    name: "Channel",
    component: () => import("@/pages/base/channel/index.vue"),
    meta: {
      title: "渠道来源",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/approve",
    name: "Approve",
    component: () => import("@/pages/base/approve/index.vue"),
    meta: {
      title: "审批配置",
      props: true,
    },
  },
  {
    path: "/base/customertrade",
    name: "Customertrade",
    component: () => import("@/pages/base/customertrade/index.vue"),
    meta: {
      title: "客户行业",
      search: true,
      props: true,
    },
  },
  {
    path: "/base/approve/detail",
    name: "ApproveDetail",
    component: () => import("@/pages/base/approve/detail/detail.vue"),
    meta: {
      title: "审批配置详情",
      // search:true,
      // props:true
    },
  },

  {
    path: "/repair/repairConfirm",
    name: "repairConfirm",
    component: () => import("@/pages/repair/repairConfirm/index.vue"),
    meta: {
      title: "维修确认",
      search: true,
      props: true,
    },
  },
  {
    path: "/repair/repairQuery",
    name: "repairQuery",
    component: () => import("@/pages/repair/repairQuery/index.vue"),
    meta: {
      title: "维修查询",
      search: true,
      props: true,
    },
  },
  {
    path: "/repair/repairgroup",
    name: "RepairGroup",
    component: () => import("@/pages/repair/repairgroup/index.vue"),
    meta: {
      title: "维修授权",
      search: true,
      props: true,
    },
  },
  {
    path: "/repair/repairgroup/detail",
    name: "RepairGroupDetail",
    component: () => import("@/pages/repair/repairgroup/detail.vue"),
    meta: {
      title: "授权详情",
    },
  },
  {
    path: "/repair/maintainForm/completeRepair",
    name: "completeRepair",
    component: () => import("@/pages/repair/create/MaintainList/completeRepair.vue"),
    meta: {
      title: "提交维修",
    },
  },
  {
    path: "/repair/maintainForm/detail",
    name: "maintainFormDetail",
    component: () => import("@/pages/repair/maintainForm/detail.vue"),
    meta: {
      title: "维修详情",
    },
  },
  {
    path: "/repair/maintainForm",
    name: "maintainForm",
    component: () => import("@/pages/repair/maintainForm/index.vue"),
    redirect: (to) => {
      // 方法接收目标路由作为参数
      // return 重定向的字符串路径/路径对象
      return {
        path: "/repair/maintainForm/unRepaired"
      };
    },
    meta: {
      title: "维修",
      noKeepAlive: true,
    },
    children: [{
        path: "/repair/maintainForm/unRepaired",
        name: "unRepaired",
        component: () => import("@/pages/repair/maintainForm/unRepaired.vue"),
        meta: {
          title: "待维修",
          noKeepAlive: true,
          search: true,
        },
      },
      {
        path: "/repair/maintainForm/myMaintain",
        name: "myMaintain",
        component: () => import("@/pages/repair/maintainForm/myMaintain.vue"),
        meta: {
          title: "我的维修",
          noKeepAlive: true,
          search: true,
        },
      },
    ],
  },
  {
    path: "/repair/malfunction",
    name: "malfunctionList",
    component: () => import("@/pages/repair/malfunction/index.vue"),
    meta: {
      title: "故障类别列表",
      search: true,
    },
  },
  {
    path: "/attendance/info",
    name: "attendanceInfo",
    component: () => import("@/pages/attendance/info/index.vue"),
    meta: {
      title: "考勤情况",
    },
  },
  {
    path: "/attendance/month",
    name: "attendanceMonth",
    component: () => import("@/pages/attendance/info/month.vue"),
    meta: {
      title: "考勤月统计",
    },
  },
  {
    path: "/attendance/day",
    name: "attendanceDay",
    component: () => import("@/pages/attendance/info/day.vue"),
    meta: {
      title: "考勤日统计",
    },
  },
  {
    path: "/attendance/detail",
    name: "attendanceDetail",
    component: () => import("@/pages/attendance/info/detail.vue"),
    meta: {
      title: "考勤详情",
    },
  },
  {
    path: "/leave/manager",
    name: "leaveManager",
    component: () => import("@/pages/attendance/leaveForm/index.vue"),
    meta: {
      title: "请假列表",
      search: true,
    },
  },
  {
    path: "/leave/detail",
    name: "leaveFormDetail",
    component: () => import("@/pages/attendance/leaveForm/detail.vue"),
    meta: {
      title: "请假详情",
    },
  },
  {
    path: "/workovertime/manager",
    name: "workovertime",
    component: () => import("@/pages/attendance/workovertime/index.vue"),
    meta: {
      title: "加班列表",
      search: true,
    },
  },
  {
    path: "/workovertime/detail",
    name: "workovertimeDetail",
    component: () => import("@/pages/attendance/workovertime/detail.vue"),
    meta: {
      title: "加班详情",
    },
  },
  {
    path: "/attendance/dayList",
    name: "attendanceDayList",
    component: () => import("@/pages/attendance/info/dayList.vue"),
    meta: {
      title: "日列表",
    },
  },
  {
    path: "/auditFactory/creat/list",
    name: "auditFactory",
    component: () => import("@/pages/auditFactory/creat/list.vue"),
    meta: {
      title: "审厂申请",
      search: true,
    },
  },
  {
    path: "/auditFactory/creat/detail",
    name: "auditFactoryDetail",
    component: () => import("@/pages/auditFactory/creat/detail.vue"),
    meta: {
      title: "审厂申请详情",
    },
  },
  {
    path: "/auditFactory/confirm/list",
    name: "auditFactoryApproval",
    component: () => import("@/pages/auditFactory/confirm/list.vue"),
    meta: {
      title: "审厂审批",
      search: true,
    },
  },
  {
    path: "/auditFactory/confirm/detail",
    name: "auditFactoryApprovalDetail",
    component: () => import("@/pages/auditFactory/confirm/detail.vue"),
    meta: {
      title: "审厂申请详情",
    },
  },
  {
    path: "/auditFactory/form/list",
    name: "auditFactoryFormEdit",
    component: () => import("@/pages/auditFactory/form/list.vue"),
    meta: {
      title: "评审资料填写",
      search: true,
    },
  },
  {
    path: "/auditFactory/form/detail",
    name: "auditFactoryFormDetail",
    component: () => import("@/pages/auditFactory/form/detail.vue"),
    meta: {
      title: "评审资料详情",
    },
  },
  {
    path: "/auditFactory/success/list",
    name: "auditFactoryFormSuccess",
    component: () => import("@/pages/auditFactory/success/list.vue"),
    meta: {
      title: "评审确认",
      search: true,
    },
  },
  {
    path: "/auditFactory/success/detail",
    name: "auditFactoryFormSuccessDetail",
    component: () => import("@/pages/auditFactory/success/detail.vue"),
    meta: {
      title: "评审资料详情",
    },
  },

  //日报 月报
  {
    path: "/conclusion/dayConclusion",
    name: "DayConclusion",
    component: () => import("@/pages/conclusion/dayConclusion/index.vue"),
    meta: {
      title: "日总结",
      search: true,
    },
  },
  {
    path: "/conclusion/edit",
    name: "ConclusionEdit",
    component: () => import("@/pages/conclusion/edit.vue"),
    meta: {
      title: "总结",
    },
  },
  {
    path: "/conclusion/monthConclusion",
    name: "MonthConclusion",
    component: () => import("@/pages/conclusion/monthConclusion/index.vue"),
    meta: {
      title: "月总结",
      search: true,
    },
  },
  {
    path: "/conclusion/weekConclusion",
    name: "WeekConclusion",
    component: () => import("@/pages/conclusion/weekConclusion/index.vue"),
    meta: {
      title: "周总结",
      search: true,
    },
  },

  {
    path: "/customerEvaluation",
    name: "customerEvaluationList",
    component: () => import("@/pages/customerEvaluation/index.vue"),
    meta: {
      title: "客户评价",
      search: true,
    },
  },
  //用车管理
  {
    path: "/vehicleManagement",
    name: "vehicleManagement",
    component: () => import("@/pages/vehicleManagement/index.vue"),
    meta: {
      title: "用车管理",
      search: true,
    }
  },
  {
    path: "/vehicleManagement/detail",
    name: "vehicleManagementDetail",
    component: () => import("@/pages/vehicleManagement/detail.vue"),
    meta: {
      title: "用车管理",
    }
  },



  {
    path: "/:pathMatch(.*)*",
    name: "NotFind",
    component: () => import("@/pages/notFound.vue"),
  },
];

function getPageNames(noKeepAlivePages, routes) {
  for (let item of routes) {
    if (item.meta && item.meta.noKeepAlive) {
      noKeepAlivePages.push(item.name);
    }
    if (item.children && item.children.length > 0) {
      getPageNames(noKeepAlivePages, item.children);
    }
  }
}

export default {
  getRoutes() {
    return routes;
  },
  getNoKeepAlivePages() {
    let pages = [];
    getPageNames(pages, routes);
    return pages;
  },
};